import { useState } from "react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Plus } from "lucide-react";
import AdminLinkSubmitForm from "./AdminLinkSubmitForm";

/** Modal wrapper around the shared admin link submission form. */
export default function AdminUrlSubmitModal({ open, onOpenChange, onSubmitted }) {
  const handleSubmitted = (result) => {
    onOpenChange?.(false);
    onSubmitted?.(result);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Submit Link for Customer</DialogTitle>
        </DialogHeader>
        <AdminLinkSubmitForm compact onSubmitted={handleSubmitted} />
      </DialogContent>
    </Dialog>
  );
}

/** Prominent admin action: opens {@link AdminUrlSubmitModal}. */
export function AdminUrlSubmitAction({ onSubmitted, className = "" }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        className={className || "bg-orange-600 hover:bg-orange-700 text-white"}
        onClick={() => setOpen(true)}
        data-testid="admin-submit-url-open"
      >
        <Plus className="h-4 w-4 mr-2" />
        Submit Link for Customer
      </Button>
      <AdminUrlSubmitModal open={open} onOpenChange={setOpen} onSubmitted={onSubmitted} />
    </>
  );
}
